import { classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { z } from 'zod';
export const abmsCertificationSchema = classifierSchema.merge(z.object({}));
export const abnsCertificationSchema = classifierSchema.merge(z.object({}));
export const abppCertificationSchema = classifierSchema.merge(z.object({}));
export const aoaCertificationSchema = classifierSchema.merge(z.object({}));
export const aprnSpecialtySchema = classifierSchema.merge(z.object({}));
export const ascpSpecialtySchema = classifierSchema.merge(z.object({}));
export const boardOfPharmaceuticalSpecialtySchema = classifierSchema.merge(z.object({}));
export const cardiovascularSpecialtySchema = classifierSchema.merge(z.object({}));
export const dentalSpecialtySchema = classifierSchema.merge(z.object({}));
export const deploymentDurationSchema = classifierSchema.merge(z.object({
    durationLength: z.number(),
}));
export const deploymentTravelWillingnessSchema = classifierSchema.merge(z.object({
    displayOrder: z.number().optional(),
}));
export const deploymentTypeSchema = classifierSchema.merge(z.object({}));
export const physicianAssistantExperienceSchema = classifierSchema.merge(z.object({}));
export const driverLicenseEndorsementSchema = classifierSchema.merge(z.object({
    displayOrder: z.number().optional(),
}));
export const emergencyContactRelationshipSchema = classifierSchema.merge(z.object({
    displayOrder: z.number().optional(),
}));
export const eyeColorSchema = classifierSchema.merge(z.object({
    ansiD20Code: z.string().trim().min(1),
}));
export const hairColorSchema = classifierSchema.merge(z.object({
    ansiD20Code: z.string().trim().min(1),
}));
export const hospitalCategories = [
    'city',
    'clinic',
    'county',
    'ems',
    'hospital',
    'laboratory',
    'unknown',
    'office',
    'other',
    'pharmacy',
    'state',
];
export const hospitalCategorySchema = z.enum(hospitalCategories);
export const hospitalSchema = classifierSchema.merge(z.object({
    addressLine1: z.string().optional(),
    addressLine2: z.string().optional(),
    category: z.enum(hospitalCategories).optional(),
    city: z.string().optional(),
    contactNumber: z.string().optional(),
    emergencyContactNumber: z.string().optional(),
    state: z.string().optional(),
    zip: z.string().optional(),
    automaticVerification: z.boolean().optional(),
    affiliationVerifiable: z.boolean().optional(),
}));
export const incidentTypeSchema = classifierSchema.merge(z.object({}));
export const jasBoardPropertyTypeSchema = z.enum(['required', 'optional']).optional();
export const jasBoardSchema = classifierSchema.merge(z.object({
    fieldClient: z.string().optional(), // send to JAS as client
    fieldDisciplineId: jasBoardPropertyTypeSchema.optional(), // send to JAS as disciplineId
    fieldMiddleName: jasBoardPropertyTypeSchema.optional(), // send to JAS as middleName
    fieldDateOfBirth: jasBoardPropertyTypeSchema.optional(), // send to JAS as dateOfBirth
    fieldYearOfBirth: jasBoardPropertyTypeSchema.optional(), // send to JAS as birthYear
    fieldSsnLast4Digits: jasBoardPropertyTypeSchema.optional(), // send to JAS as lastFour
    fieldCounty: jasBoardPropertyTypeSchema.optional(), // send to JAS as county
    additionalFields: z.string().array().optional(),
    testEnabled: z.boolean(),
    testResponse: z.string().optional(), // should be valid JSON
    verificationInterval: z.number().optional(),
    outOfDateAfter: z.number().optional(),
}));
export const laboratoryTechnicianSpecialtySchema = classifierSchema.merge(z.object({}));
export const laboratoryTechnologistSpecialSchema = classifierSchema.merge(z.object({}));
export const languageSchema = classifierSchema.merge(z.object({}));
export const languageFluencySchema = classifierSchema.merge(z.object({
    displayOrder: z.number().optional(),
}));
export const maritalStatusSchema = classifierSchema.merge(z.object({}));
export const medicalRecordsItSpecialtySchema = classifierSchema.merge(z.object({}));
export const mhcSpecialtySchema = classifierSchema.merge(z.object({}));
export const occupationTypes = ['medical', 'nonMedical'];
export const occupationalTypeSchema = z.enum(occupationTypes);
export const professionalStatusTypes = ['licensed', 'nonLicensed', 'inactive', 'active', 'retired', 'student'];
export const professionalStatusTypeLabel = {
    licensed: 'Licensed',
    nonLicensed: 'Non-Licensed',
    inactive: 'Inactive',
    active: 'Active',
    retired: 'Retired',
    student: 'Student',
};
export const professionalStatusTypeSchema = z.enum(professionalStatusTypes);
export const professionalStatusSchema = classifierSchema.merge(z.object({
    type: professionalStatusTypeSchema,
    occupationGroupIds: z.string().uuid().array(),
    displayOrder: z.number().optional(),
}));
export const occupationCredentialSchema = z.object({
    credentialId: z.string().trim().min(1),
    jasBoardId: z.string().optional(),
    ecl1: z.boolean(),
    ecl2: z.boolean(),
    ecl3: z.boolean(),
    ecl4: z.boolean(),
});
// TODO Use WidgetFormConfigSchema and include form into this schema when CUI-393 is done
export const occupationSchema = classifierSchema.merge(z.object({
    description: z.string().optional(),
    disciplineId: z.string().optional(),
    groupId: z.string().optional(),
    reportId: z.string().optional(),
    oNetSocCode: z.string().optional(),
    functionId: z.string().optional(),
    calculateEcl: z.boolean().optional(),
    credentials: occupationCredentialSchema.array().optional(),
    form: z.any().optional(),
}));
export const partialOccupationSchema = occupationSchema.omit({ form: true });
// TODO Use WidgetFormConfigSchema and include form into this schema when CUI-393 is done
export const occupationCredentialDataSchema = classifierSchema.merge(z.object({
    form: z.any().optional(),
}));
export const partialOccupationCredentialDataSchema = occupationCredentialDataSchema.omit({ form: true });
export const occupationFunctionSchema = classifierSchema.merge(z.object({}));
export const occupationGroupSchema = classifierSchema.merge(z.object({
    selectable: z.boolean(),
}));
export const occupationReportSchema = classifierSchema.merge(z.object({}));
export const pharmacySpecialtySchema = classifierSchema.merge(z.object({}));
export const priorCommitmentSchema = classifierSchema.merge(z.object({}));
export const radiologicSpecialtySchema = classifierSchema.merge(z.object({}));
export const referralOptionSchema = classifierSchema.merge(z.object({}));
export const trainCourseSchema = classifierSchema.merge(z.object({ trainId: z.number() }));
export const skillTypes = ['healthcare', 'other'];
export const skillTypeSchema = z.enum(skillTypes);
export const skillSchema = classifierSchema.merge(z.object({
    type: skillTypeSchema,
}));
export const trainingSchema = classifierSchema.merge(z.object({
    description: z.string().trim().min(1),
}));
export const tribeSchema = classifierSchema.merge(z.object({}));
export const veterinarianSpecialtySchema = classifierSchema.merge(z.object({}));
export const writtenAbilitySchema = classifierSchema.merge(z.object({
    displayOrder: z.number().optional(),
}));
